import React from "react";
import { X } from "lucide-react";
import { useLogContext } from "../../contexts/LogContext";

const LogFilters = () => {
  const { filters, updateFilters, formattedFilters, clearFilters } =
    useLogContext();

  const handleFilterChange = (newFilter) => {
    updateFilters(newFilter);
  };

  return (
    <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 sm:p-8 rounded-xl shadow-md max-w-7xl mx-auto">
      <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-8">
        BVN Logs Filters
      </h2>
      <div className="flex flex-col space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Search by Operator
            </label>
            <select
              value={filters.operator}
              onChange={(e) => handleFilterChange({ operator: e.target.value })}
              className="block w-full px-4 py-3 text-base bg-white border border-gray-200 rounded-lg focus:ring-0 focus:border-gray-300"
            >
              <option value="">ALL</option>
              <option value="mtn">MTN</option>
              <option value="airtel">AIRTEL</option>
              <option value="etisalat">9MOBILE</option>
            </select>
          </div>
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Start Date
            </label>
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) =>
                handleFilterChange({ startDate: e.target.value })
              }
              className="block w-full px-4 py-3 text-base bg-white border border-gray-200 rounded-lg focus:ring-0 focus:border-gray-300"
            />
          </div>
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              End Date
            </label>
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) => handleFilterChange({ endDate: e.target.value })}
              className="block w-full px-4 py-3 text-base bg-white border border-gray-200 rounded-lg focus:ring-0 focus:border-gray-300"
            />
          </div>
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              USSD Code
            </label>
            <select
              value={filters.ussdCode}
              onChange={(e) => handleFilterChange({ ussdCode: e.target.value })}
              className="block w-full px-4 py-3 text-base bg-white border border-gray-200 rounded-lg focus:ring-0 focus:border-gray-300"
            >
              <option value="">All</option>
              <option value="star0">*0</option>
              <option value="star2">*2</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end">
          <button
            onClick={clearFilters}
            className="w-full sm:w-auto bg-red-500 text-white font-semibold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center"
          >
            <X size={16} className="mr-2" />
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogFilters;
